export {
  destroy,
  success,
  error,
  info,
  warning,
  loading,
  notification,
} from './src/message';
